import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { useHome } from 'context/HomeContext';

const HomeSlider = () => {
  const { sliderImages, loading } = useHome();

  if (loading) return (
    <div className="w-11/12 max-w-6xl mx-auto aspect-[16/9] sm:aspect-[21/9] bg-gray-200 animate-pulse rounded-lg" />
  );

  if (!sliderImages.length) return null;

  return (
    <div className="w-11/12 max-w-6xl mx-auto px-1">
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000 }}
        loop={true}
        className="aspect-[16/9] sm:aspect-[21/9] rounded-lg"
      >
        {sliderImages.map((banner) => (
          <SwiperSlide key={banner.id}>
            <img
              src={banner.image}
              alt={banner.title || "Banner"}
              className="w-full h-full object-cover rounded-lg"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeSlider;
